let alertDismissInitialized = false;
import { refreshIcons } from '../../base/utils.js';

export function initAlertDismiss() {
    if (alertDismissInitialized) return;
    alertDismissInitialized = true;

    document.body.addEventListener('click', function (e) {
        const btn = e.target.closest('.alert-close');
        if (btn) {
            e.preventDefault();
            const alert = btn.closest('.alert');
            if (alert) {
                alert.style.height = alert.offsetHeight + 'px';
                alert.offsetHeight;

                alert.classList.add('alert-out');

                setTimeout(() => {
                    if (alert && alert.parentNode) {
                        alert.remove();
                    }
                }, 300);
            }
        }
    });
}
